import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QRCodeGenerator = ({ qrCodeData, userName, onCheckIn, loading }) => {
  return (
    <div className="card">
      <div className="text-center">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-foreground mb-2">Your Check-In QR Code</h2>
          <p className="text-muted-foreground">Show this code at the front desk to check in</p>
        </div>

        {/* QR Code Display */}
        <div className="flex justify-center mb-6">
          <div className="p-6 bg-white rounded-2xl shadow-lg">
            {qrCodeData ? (
              <QRCodeSVG
                value={qrCodeData}
                size={280}
                level="H"
                includeMargin={true}
                imageSettings={{
                  src: '/favicon.ico',
                  height: 40,
                  width: 40,
                  excavate: true
                }}
              />
            ) : (
              <div className="w-[280px] h-[280px] flex items-center justify-center bg-muted rounded-lg">
                <Icon name="QrCode" size={80} className="text-muted-foreground" />
              </div>
            )}
          </div>
        </div>

        {/* Member Info */}
        <div className="mb-6 p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Icon name="User" size={20} className="text-primary" />
            <span className="text-lg font-semibold text-foreground">{userName || 'Member'}</span>
          </div>
          <div className="flex items-center justify-center gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="CheckCircle" size={16} className="text-success" />
              Active Membership
            </span>
            <span className="flex items-center gap-1">
              <Icon name="Clock" size={16} />
              Valid Today
            </span>
          </div>
        </div>

        {/* Quick Check-In Button */}
        <Button
          onClick={() => onCheckIn('qr_code')}
          disabled={loading}
          className="w-full max-w-md mx-auto"
          size="lg"
        >
          {loading ? (
            <>
              <Icon name="Loader2" size={20} className="animate-spin" />
              <span>Checking In...</span>
            </>
          ) : (
            <>
              <Icon name="LogIn" size={20} />
              <span>Quick Check-In</span>
            </>
          )}
        </Button>

        {/* Instructions */}
        <div className="mt-8 p-4 bg-primary/5 rounded-lg border border-primary/20">
          <h3 className="font-semibold text-foreground mb-3 flex items-center justify-center gap-2">
            <Icon name="Info" size={18} className="text-primary" />
            How to Use
          </h3>
          <ul className="text-sm text-muted-foreground space-y-2 text-left max-w-md mx-auto">
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} className="text-success mt-0.5" />
              <span>Show this QR code to staff at the front desk</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} className="text-success mt-0.5" />
              <span>Or tap Quick Check-In to record your visit</span>
            </li>
            <li className="flex items-start gap-2">
              <Icon name="Check" size={16} className="text-success mt-0.5" />
              <span>Your QR code refreshes automatically for security</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator;